module.exports = __webpack_public_path__ + "static/img/banner1.624b1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner1.jpg
// module id = h9wa
// module chunks = 1